import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './index.css';
import React from 'react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { BrightcoveVideoPlayer } from '../BrightcoveVideoPlayer';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { get, getDictionaryItem, canUseDOM } from '../../utils';
import LazyPicture from '../atoms/LazyPicture';
import { ReactComponent as IcPlayWhite } from '../../resources/icons/ic-play-white.svg';
import { DropdownResults } from '../Listing/DropdownResults';
import { handleAnalitics as _handleAnalitics } from '../../utils/tealium';
import VolumeControl from '../BrightcoveVideosAtoms/VolumeControl';
import SocialSharingControl from '../BrightcoveVideosAtoms/SocialSharingControl';
import LikeControl from '../BrightcoveVideosAtoms/LikeControl';
import DarkThemeControl from '../BrightcoveVideosAtoms/DarkThemeControl';
/* import useProfile from '../../utils/hooks/useProfile'; */

export var addCustomBreadcrumb = function addCustomBreadcrumb() {
  if (canUseDOM) {
    var breadcrump = document.querySelector('header .breadcrumb-nav');
    if (breadcrump) breadcrump.setAttribute('hidden', '');
  }
};
export var VideosDropdown = function VideosDropdown(_ref) {
  var videoGenres = _ref.videoGenres,
    overviewButton = _ref.overviewButton,
    params = _ref.params,
    analytics = _ref.analytics,
    label = _ref.label;
  var generateOptions = function generateOptions() {
    var genders = [],
      optionsArr = [];
    if (videoGenres && overviewButton) {
      videoGenres.forEach(function (element) {
        var item = get(element, 'title.jss.value');
        var name = get(element, 'name');
        if (item) {
          optionsArr.push({
            title: item,
            url: "".concat(overviewButton, "?category=").concat(item),
            name: name
          });
        }
      });
    }
    return optionsArr;
  };
  return /*#__PURE__*/React.createElement(DropdownResults, {
    filteredOptions: generateOptions(),
    label: label,
    customClass: "brightcoveHeader__dropdown",
    handleAnalitics: function handleAnalitics(el) {
      return _handleAnalitics({
        params: params,
        title: el,
        objectParamName: "Category Selection Param",
        objectParams: analytics
      });
    }
  });
};
export var setDarkMode = function setDarkMode() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (typeof window !== 'undefined') if (value) {
    document.querySelector('body').classList.add('dark');
  } else {
    document.querySelector('body').classList.remove('dark');
  }
};
var BrightcoveVideosHeader = function BrightcoveVideosHeader(_ref2) {
  var fields = _ref2.fields,
    params = _ref2.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var darkMode = sitecoreContext.darkMode,
    videosList = sitecoreContext.videosList;
  var actions = get(sitecoreContext, 'actions', {});
  /* const userProfile = useProfile(); */

  var _actions$changeThemeF = actions.changeThemeFunction,
    changeThemeFunction = _actions$changeThemeF === void 0 ? function () {} : _actions$changeThemeF,
    _actions$getLikes = actions.getLikes,
    getLikes = _actions$getLikes === void 0 ? function () {} : _actions$getLikes,
    _actions$fetchUserSet = actions.fetchUserSettings,
    fetchUserSettings = _actions$fetchUserSet === void 0 ? function () {} : _actions$fetchUserSet,
    _actions$setLike = actions.setLike,
    setLike = _actions$setLike === void 0 ? function () {} : _actions$setLike,
    _actions$setVideoVolu = actions.setVideoVolumeFunction,
    setVideoVolumeFunction = _actions$setVideoVolu === void 0 ? function () {} : _actions$setVideoVolu;
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var items = get(fields, 'data.datasource.videos.video', []);
  var moveToFirstButton = React.useRef(null);
  var dictionary = get(fields, 'data.dictionary');
  var playMovieTitle = getDictionaryItem(dictionary, 'play movie') || '';
  var findOutMoreTitle = getDictionaryItem(dictionary, 'find out more') || '';
  var darkModeTitle = getDictionaryItem(dictionary, "dark mode") || '';
  var selectTitle = getDictionaryItem(dictionary, 'selectCategory') || '';
  var shortThousand = getDictionaryItem(dictionary, 'shortThousand') || '';
  var overviewButton = get(fields, 'data.overviewButton.link.jss.value.href');
  var videoGenres = get(fields, 'data.videoGenres.dictionaryValues');
  var breadcrumb = get(sitecoreContext, 'breadcrumb');
  var themesOfPage = get(sitecoreContext, 'themesOfPage');
  var breadcrumbAnalytics = get(sitecoreContext, 'breadcrumbAnalytics');
  var accountId = get(fields, 'data.videoSetting.publisherID.jss.value');
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeSlide = _React$useState2[0],
    changeActiveSlide = _React$useState2[1];
  var _React$useState3 = React.useState(get(sitecoreContext, 'volume')),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    volume = _React$useState4[0],
    _setVolume = _React$useState4[1];
  var isMobile = canUseDOM ? window.matchMedia("(max-width: 768px)").matches : false;
  var analytics = get(fields, 'data.analytics.parameters');
  var videoSocialSharing = get(fields, 'data.videoSocialSharing');
  var volumeProp = get(sitecoreContext, 'volume');
  var moduleRef = React.useRef(null);
  var usePrevious = function usePrevious(value) {
    var ref = React.useRef();
    React.useEffect(function () {
      ref.current = value;
    });
    return ref.current;
  };
  var prevAmount = usePrevious({
    volumeProp: volumeProp
  }) || {};
  var videoIds = items.reduce(function (result, item) {
    if (get(item, 'video.jss.fields.ID.value')) {
      result.push(get(item, 'video.jss.fields.ID.value'));
    }
    return result;
  }, []);
  if (!fields) {
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[BrightcoveVideosHeader component is empty: please provide data source]");
    }
    return null;
  }
  //setDarkMode(darkMode)
  // eslint-disable-next-line react-hooks/rules-of-hooks
  React.useEffect(function () {
    //setVolume(get(sitecoreContext, 'volume'))
  }, [sitecoreContext.volume]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  React.useEffect(function () {
    if (prevAmount && prevAmount.volumeProp !== get(sitecoreContext, 'volume')) {
      //setVolume(get(sitecoreContext, 'volume'))
    }
  }, [sitecoreContext]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  React.useEffect(function () {
    addCustomBreadcrumb();
    if (videoIds && videoIds.length) getLikes(videoIds);
    fetchUserSettings();
  }, []);
  var endVideoHandler = function endVideoHandler(isEnd) {
    if (moveToFirstButton.current) {
      moveToFirstButton.current.click();
    }
  };
  var renderButtonRow = function renderButtonRow(url, name, showButton, videoSetting, videoId) {
    return /*#__PURE__*/React.createElement("div", {
      className: "brightcoveHeader__item--buttonRow"
    }, /*#__PURE__*/React.createElement("div", {
      className: "brightcoveHeader__item--buttonRow-btn"
    }, videoId && /*#__PURE__*/React.createElement("a", {
      className: "btn btn-primary btn-play buttonRow__btn--btn-lvl1",
      href: url + '?play=true',
      "aria-label": "Play Movie",
      "aria-labelledby": "Play Movie",
      onClick: function onClick() {
        return _handleAnalitics({
          params: params,
          title: name,
          objectParamName: "Play Movie Param",
          objectParams: analytics
        });
      }
    }, /*#__PURE__*/React.createElement(IcPlayWhite, null), " ", /*#__PURE__*/React.createElement("span", null, playMovieTitle)), /*#__PURE__*/React.createElement("a", {
      className: "btn btn-secondary buttonRow__btn--btn-lvl1",
      href: url,
      "aria-label": "Find Out More",
      "aria-labelledby": "Find Out More",
      onClick: function onClick() {
        return _handleAnalitics({
          params: params,
          title: name,
          objectParamName: "Find Out More Param",
          objectParams: analytics
        });
      }
    }, findOutMoreTitle)), /*#__PURE__*/React.createElement("div", {
      className: "brightcoveHeader__item--control-btn"
    }, /*#__PURE__*/React.createElement(SocialSharingControl, {
      videoSocialSharing: videoSocialSharing,
      shareLink: url,
      analytics: analytics,
      name: name,
      params: params
    }), videoId && /*#__PURE__*/React.createElement(LikeControl, {
      analytics: analytics,
      name: name,
      params: params,
      rtl: rtl,
      shortThousand: shortThousand,
      handleClick: function handleClick() {
        return setLike(videoId);
      },
      count: videoSetting ? videoSetting.likes : 1000,
      like: videoSetting ? videoSetting.like : false
    }), showButton ? /*#__PURE__*/React.createElement(VolumeControl, {
      setVolume: function setVolume(e) {
        _setVolume(e);
        setVideoVolumeFunction(e);
      },
      volume: volume
    }) : null));
  };
  var renderItems = function renderItems(carousel) {
    return items.map(function (item, i) {
      var fallbackImage = get(item, 'fallbackImage.jss.value');
      var mobileImage = get(item, 'mobileImage.jss.value');
      var imgResult = isMobile && mobileImage && mobileImage.src ? mobileImage : fallbackImage;
      var icon = get(item, 'icon.jss.value');
      var title = get(item, 'title.jss.value');
      var introText = get(item, 'introText.jss.value');
      var url = get(item, 'url');
      var name = get(item, 'name');
      var category = get(item, 'category.targetItem.title.jss.value');
      var teaserId = get(item, 'teaser.jss.fields.ID.value');
      var teaserMobile = get(item, 'teaserMobile.jss.fields.ID.value');
      var videoId = get(item, 'video.jss.fields.ID.value');
      var videoSetting = videosList && videosList.length ? videosList.filter(function (v) {
        return v.videoId == videoId;
      })[0] : {
        videoId: videoId,
        likes: 0,
        like: false
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "brightcoveHeader__item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "brightcoveHeader__item--bg"
      }, (isMobile && teaserMobile || teaserId) && activeSlide == i ? /*#__PURE__*/React.createElement(BrightcoveVideoPlayer, {
        endVideoHandler: endVideoHandler,
        volume: volume,
        loop: items.length == 1,
        autoPlay: carousel && i == 0 ? true : false,
        muted: true,
        isPreview: true,
        videoId: isMobile && teaserMobile ? teaserMobile : teaserId,
        accountId: accountId,
        closeVideo: function closeVideo() {},
        changeVolumeFunc: function changeVolumeFunc(e) {
          _setVolume(e);
          setVideoVolumeFunction(e);
        },
        themesOfPage: themesOfPage,
        rtl: rtl
      }) : /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 768px)",
        srcSet: imgResult.src
      }), /*#__PURE__*/React.createElement("img", {
        src: imgResult.src,
        alt: imgResult.alt
      }))), /*#__PURE__*/React.createElement("div", {
        className: "brightcoveHeader__item--content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "module-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-md-1 col-md-11"
      }, icon && /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 768px)",
        srcSet: icon.src
      }), /*#__PURE__*/React.createElement("img", {
        src: icon.src,
        alt: title
      })), category && /*#__PURE__*/React.createElement("div", {
        className: "brightcoveHeader__item--categories"
      }, /*#__PURE__*/React.createElement("a", {
        href: "".concat(overviewButton, "?category=").concat(encodeURIComponent(category))
      }, /*#__PURE__*/React.createElement("span", null, category))), /*#__PURE__*/React.createElement("h2", null, title), /*#__PURE__*/React.createElement("p", null, introText), url && renderButtonRow(url, name, isMobile && teaserMobile || teaserId, videoSetting, videoId))))));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "brightcoveHeader ",
    ref: moduleRef,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group brightcoveHeader__controls",
    style: {
      paddingTop: '0px',
      paddingBottom: '0px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row container__dark_mode_switcher"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-md-1 col-md-5 col-6"
  }, /*#__PURE__*/React.createElement(VideosDropdown, {
    overviewButton: overviewButton,
    videoGenres: videoGenres,
    analytics: analytics,
    params: params,
    label: selectTitle
  })), /*#__PURE__*/React.createElement("div", {
    className: "dark_mode_switcher col-md-3 col-5"
  }, params && params['Dark Mode Switcher Show'] && /*#__PURE__*/React.createElement(DarkThemeControl, {
    handleClick: changeThemeFunction,
    label: darkModeTitle,
    value: darkMode,
    params: params,
    analytics: analytics
  })))), /*#__PURE__*/React.createElement(CarouselProvider, {
    getCurrentActiveItem: function getCurrentActiveItem(i) {
      return changeActiveSlide(i);
    },
    moduleRef: moduleRef
  }, function (_ref3) {
    var renderCarousel = _ref3.renderCarousel,
      renderPreviousButton = _ref3.renderPreviousButton,
      renderNextButton = _ref3.renderNextButton,
      renderDots = _ref3.renderDots,
      moveToSlide = _ref3.moveToSlide;
    return /*#__PURE__*/React.createElement("div", {
      className: rtl ? 'item-rtl-carousal-fix' : ''
    }, renderCarousel(renderItems(true), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 1023,
            min: 0
          },
          items: 1
        }
      }
    }, function (isNext) {
      return _handleAnalitics({
        params: params,
        title: '',
        objectParamName: isNext ? 'Slide Right Param' : 'Slide Left Param',
        objectParams: analytics
      });
    }), /*#__PURE__*/React.createElement("div", {
      className: "header-bb__controls-sec"
    }, /*#__PURE__*/React.createElement("div", {
      className: "header-bb__control-left d-none d-md-block"
    }, rtl ? renderNextButton(function () {
      return _handleAnalitics({
        params: params,
        title: '',
        objectParamName: 'Next Param',
        objectParams: analytics
      });
    }) : renderPreviousButton(function () {
      return _handleAnalitics({
        params: params,
        title: '',
        objectParamName: 'Previous Param',
        objectParams: analytics
      });
    })), /*#__PURE__*/React.createElement("div", {
      className: "header-bb__control-right d-none d-md-block"
    }, rtl ? renderPreviousButton(function () {
      return _handleAnalitics({
        params: params,
        title: '',
        objectParamName: 'Previous Param',
        objectParams: analytics
      });
    }) : renderNextButton(function () {
      return _handleAnalitics({
        params: params,
        title: '',
        objectParamName: 'Next Param',
        objectParams: analytics
      });
    }))), /*#__PURE__*/React.createElement("div", {
      className: "header__pagination-dots"
    }, /*#__PURE__*/React.createElement("div", {
      className: "module-group"
    }, renderDots(function () {
      return _handleAnalitics({
        params: params,
        title: '',
        objectParamName: 'Navigator Bubbles Param',
        objectParams: analytics
      });
    }))), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        moveToSlide(activeSlide == items.length - 1 ? 0 : activeSlide + 1);
      },
      ref: moveToFirstButton,
      className: "d-none"
    }, "move to slide 0"));
  })));
};
var StyledWrapper = function StyledWrapper(_ref4) {
  var children = _ref4.children,
    rtl = _ref4.rtl;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    fullWidth: true,
    minHeight: true,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    componentTabIndex: "disabled"
  }, children);
};
export var commonStyles = "c12go75n";
var rtlStyles = "r1ucfe7x";
var ltrStyles = "l1n3qisa";
var globals = "gx4n3fx";
export default BrightcoveVideosHeader;